import createMessages from 'mz-intl/create';

export default createMessages('MZ_SEARCH_FORM', {
  PARKING: 'Parking',
  PARKING_LOCATION: 'Parking location',
  PICKUP_DATE: 'Pickup Date',
  PICKUP_TIME: 'Pickup Time',
  PARKING_PICKUP_DATE: 'End parking date',
  PARKING_PICKUP_TIME: 'End parking time',
  PARKING_DROPOFF_DATE: 'Start parking date',
  PARKING_DROPOFF_TIME: 'Start parking time',
  HOURLY: 'Hourly Ride',
  POINT_TO_POINT: 'Point-to-Point',
  SEARCH: 'Search',
  PARKING_TITLE: 'Reserve your parking spot',
  ESIM: 'eSIM',
});
